import React, { useState, useEffect } from 'react';
import { Row, Col, Spin } from 'antd';
import { makeRequest } from '@utils/helpers';
import { getDailyAbsentsReq, getLateArrivalsReq } from '../requests';
import "../dashboard.css"
import ReactApexChart from 'react-apexcharts';
import { InputDate } from '@comps/components';
import dayjs from 'dayjs';
const moment = require('moment');

const DailyAbsents = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(moment());

  useEffect(() => {
    let payload = {
      "date": startDate ? startDate.format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD'),
    }
    makeRequest(setLoader, getDailyAbsentsReq, payload, onSuccess, onError)
  }
    , [startDate]);

  const onSuccess = (data) => {
    setData(data.daily_absents);
  }

  const onError = (error) => {
  }

  return (
    <div className='widgetbox' >
      <Row>
        <Col span={ 12 }>
          <h3>Absents</h3>
        </Col>
        <Col span={ 12 }>
          <div className='changeDate'>
            <Row gutter={ 10 }>
              <Col span={ 24 }>
                <InputDate onChange={ setStartDate } defaultValue={ dayjs(startDate) } placeholder="Date" />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <div className='widgetcontent widgetboxfixH'>
        <Spin spinning={ loader } tip="Loading...">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Code</th>
              </tr>
            </thead>
            <tbody>
              { data && data.map((row, index) =>
                <tr>
                  <th scope="row">{ index + 1 }</th>
                  <td>{ row.full_name }</td>
                  <td>{ row.emp_code }</td>
                </tr>
              ) }

            </tbody>
          </table>
        </Spin>
      </div>
    </div>
  );
}

export default DailyAbsents;